const automations = {
  table: {
    header: {
      suppliers: 'ציים',
    },
    filters: {
      suppliers: {
        title: 'ציים',
      },
    },
  },
  wizard: {
    information: {
      supplier: 'ציים',
    },
  },
};

export default automations;
